import { render, staticRenderFns } from "./serialPack.vue?vue&type=template&id=221c13e1&"
import script from "./serialPack.vue?vue&type=script&lang=js&"
export * from "./serialPack.vue?vue&type=script&lang=js&"
import style0 from "./serialPack.vue?vue&type=style&index=0&id=221c13e1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports